import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import BabyPage from "./pages/BabyPage";
import Whoops from "./pages/Whoops";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import RSVP from "./pages/RSVP";
import Result from "./pages/Result";
import QuizFinal from "./pages/QuizFinal";
import Reservations from "./pages/Reservations";
import Manage from "./pages/Manage";
import ListPage from "./pages/ListPage";
import Admin from "./pages/Admin";
import ProtectedRoute from "./components/ProtectedRoute";
import './DarkTheme.css';

export default function AllRoutes(){
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/quiz" element={
                <ProtectedRoute>
                    <Quiz />
                </ProtectedRoute>
            } />
            <Route path="/rsvp" element={
                <ProtectedRoute>
                    <RSVP />
                </ProtectedRoute>
            } />
            <Route path="/reservations" element={
                <ProtectedRoute>
                    <Reservations />
                </ProtectedRoute>
            } />
            <Route path="/list" element={
                <ProtectedRoute>
                    <ListPage />
                </ProtectedRoute>
            } />
            <Route path="/baby" element={<BabyPage />} />
            <Route path="/Result" element={
                <ProtectedRoute>
                    <Result />
                </ProtectedRoute>
            } />
            <Route path="/QuizFinal" element={
                <ProtectedRoute>
                    <QuizFinal />
                </ProtectedRoute>
            } />
            <Route path="/manage" element={
                <ProtectedRoute>
                    <Manage />
                </ProtectedRoute>
            } />
            <Route path="/admin" element={
                <ProtectedRoute>
                    <Admin />
                </ProtectedRoute>
            } />
            <Route path="*" element={<Whoops />} />
        </Routes>
    )
}